import React, { useState } from 'react'
import { useQuery } from '@tanstack/react-query'
import { Pagination } from 'packages/eid-ui'
import { usePageContext } from 'pageContext'

const useApiWithInfiniteScroll = (
    queryKey,
    queryFn,
    queryConfig,
    defaultTake = 15,
) => {
    const [{ page }, dispatch] = usePageContext()
    let minimumRowsPerPage
    const [perPage, setPerPage] = useState(defaultTake)
    const handlePageChange = (_, value) => {
        dispatch({
            type: 'SET_PAGE',
            payload: value,
        })
    }

    if (defaultTake < 10) {
        minimumRowsPerPage = defaultTake
    }

    const handlePageSelection = (value) => {
        dispatch({
            type: 'SET_PAGE',
            payload: value,
        })
    }

    const skip = (page - 1) * perPage
    const take = perPage

    const { data, error, refetch } = useQuery(
        [...queryKey, skip, take],
        () => queryFn(skip, take),
        queryConfig,
    )

    const isLoading = !Boolean(data)

    const numberOfPages = data ? Math.ceil(data.totalCount / take) : 0

    const pagination = !isLoading && (
        <Pagination
            count={numberOfPages}
            size="large"
            page={page}
            onChange={handlePageChange}
            parentIndex={9}
            showPageSelection={true}
            onPageSelection={handlePageSelection}
            minimumRowsPerPage={minimumRowsPerPage}
            showItemsPerPageSelection={true}
            onItemsPerPageChange={(val) => {
                dispatch({
                    type: 'SET_PAGE',
                    payload: 1,
                })
                dispatch({
                    type: 'SET_SUBPAGE',
                    payload: 1,
                })
                setPerPage(val)
            }}
            itemsPerPage={perPage}
            showCountStat={true}
            totalCount={data?.totalCount}
        />
    )

    return {
        loading: isLoading,
        list: data ? data.data : undefined,
        totalCount: data ? data.totalCount : undefined,
        pagination,
        error,
        refetch,
    }
}

export default useApiWithInfiniteScroll
